import React from "react";

interface DistanceViewIconProps {
  color: string
  onClick?: () => void;
}

export function DistanceViewIcon({ color, onClick }: DistanceViewIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="26"
      height="26"
      fill="none"
      viewBox="0 0 24 27"
      onClick={onClick}
      cursor='pointer'
    >
      <path
        stroke={color}
        strokeLinejoin="round"
        strokeWidth="2"
        d="M1.5 3.876v19.248L12.167 25.5v-24L1.5 3.876zM22.834 23.124V3.876L12.167 1.5v24l10.667-2.376z"
      />
    </svg>
  );
}


